import { Component, inject } from '@angular/core';
import { LANGS } from '../../shared/constants/lang.constants';
import { ReactiveFormsModule } from '@angular/forms';
import { TextComponent } from '../../shared/components/text/text.component';
import { TagComponent } from '../../shared/components/tag/tag.component';
import { MatTab, MatTabGroup } from '@angular/material/tabs';
import { Router } from '@angular/router';
import { SharedStorageService } from '../../shared/services/shared-storage.service';
import { CreateMemberRequest } from '../../shared/interfaces/set-password.model';
import { TranslatePipe } from '@ngx-translate/core';
import { MatButton } from '@angular/material/button';
import { MyReportsComponent } from '../reports/my-reports.component';
import { DatePipe } from '@angular/common';
import { FormatDatePipe2 } from '../../pipes/format-date.pipe';
import { MatDialog } from '@angular/material/dialog';
import { SavePhoneDialogComponent } from '../../shared/components/dialogs/save-phone-dialog/save-phone-dialog.component';

/**
 * 我的健康檔案
 */
@Component({
  selector: 'app-my-health-profile',
  imports: [
    ReactiveFormsModule,
    TextComponent,
    TagComponent,
    MatTab,
    MatTabGroup,
    TranslatePipe,
    MatButton,
    MyReportsComponent,
    DatePipe,
  ],
  templateUrl: './my-health-profile.component.html',
  styleUrl: './my-health-profile.component.scss',
})
export class MyHealthProfileComponent {
  LANGS = LANGS;
  selectedTab: number = 0; // 預設顯示第一個 tab
  router: Router = inject(Router);
  sharedStorageService: SharedStorageService = inject(SharedStorageService);
  dialog: MatDialog = inject(MatDialog);
  createMemberRequest: CreateMemberRequest | null = null;
  isLoading: boolean = true;
  noData: boolean = false;
  formatDatePipe2 = new FormatDatePipe2();
  isProfileVisible: boolean = false;
  maskDots: number[] = [];

  ngOnInit() {
    // 取得會員資料
    this.createMemberRequest =
      this.sharedStorageService.get('createMemberRequest') || null;
    // 沒有手機號碼時，直接在本頁彈出新增手機彈窗（不導走，稍後填寫即停留查看檔案）
    if (!this.createMemberRequest?.cell) {
      this.openSavePhoneDialog();
    }
    if (this.createMemberRequest) {
      this.isLoading = false;
      this.maskDots = Array(this.createMemberRequest.name?.length || 4).fill(0);
    }
  }

  // 開啟新增手機彈窗
  private openSavePhoneDialog(): void {
    const savePhoneDialog = this.dialog.open(SavePhoneDialogComponent, {
      disableClose: true,
      autoFocus: false,
      data: {
        isCreate: true,
        idNo: this.createMemberRequest?.idNo ?? '',
        chartNo: this.createMemberRequest?.chartNo ?? '',
        hideCancel: true, // 顯示「稍後填寫」而非取消
      },
    });

    savePhoneDialog.afterClosed().subscribe((result: string) => {
      // 'later'（稍後填寫）或未輸入 → 不寫入手機號碼，直接停留在檔案頁
      if (!result || result === 'later') return;

      // 儲存成功，將手機號碼寫回 sharedStorage 與畫面
      const memberRequest = this.sharedStorageService.get(
        'createMemberRequest'
      );
      if (memberRequest) {
        memberRequest.cell = result;
        this.sharedStorageService.set('createMemberRequest', memberRequest);
        this.createMemberRequest = memberRequest;
      }
    });
  }

  // 取得姓名
  get userName(): string {
    return this.createMemberRequest?.name || '';
  }

  // 取得性別
  get userGender(): string {
    return this.createMemberRequest?.gender === 'M' ? '男性' : '女性';
  }

  // 取得生日
  get userBirthday(): string {
    const birthday = this.createMemberRequest?.birthday ?? '';
    return this.formatDatePipe2.transform(birthday);
  }

  // 導轉修改個人資料頁面
  modifyProfile() {
    this.router.navigate(['/healthcheck/member/editprofile']).then();
  }

  // 顯示個資遮罩
  toggleProfileVisibility(): void {
    this.isProfileVisible = !this.isProfileVisible;
  }
}
